/**
 * KimlikBelgesiYonlendirme.jsx — Kişi Detay › İSG Belgeleri › Meslek › Kimlik Fotoğrafı inceleme penceresinde Onayla / Reddet / Beklemede'ye al
 * yerine duran tek satır ve düğme (#719).
 *
 * Kimlik / pasaport belgesinin kararı Kimlik Doğrula penceresindedir (Pasaport bölümü ve kapının kararı). Genel inceleme ucu
 * (PATCH /personnel/documents/{fileId}/review) kimlik durumuna dokunmaz, bu yüzden iki durum birbiriyle çelişebilirdi (ör. durum 3
 * "Belge onaylı" yanında reddedilmiş dosya). Düğme Kimlik Doğrula penceresini açar; çağıran bu pencereyi kapatır.
 *
 * Props: onAc — Kimlik Doğrula penceresini açar.
 */
import React from "react";
import { Alert, Button } from "reactstrap";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function KimlikBelgesiYonlendirme({ onAc }) {
  const { t } = useTranslation("components");
  return (
    <Alert fade={false} color="info" className="small py-2 mt-3 mb-0 d-flex align-items-center gap-2 flex-wrap">
      <span className="me-auto">{t("kimlikDogrulama.belgeKontrollerdeOnaylanir")}</span>
      <Button color="primary" size="sm" onClick={onAc}>
        <ShieldCheck size={14} className="me-1" />{t("kimlikDogrulama.kimlikDogrulaAc")}
      </Button>
    </Alert>
  );
}
